import { render, staticRenderFns } from "./MensalidadesDashboard.vue?vue&type=template&id=9c468866&scoped=true"
import script from "./MensalidadesDashboard.vue?vue&type=script&lang=js"
export * from "./MensalidadesDashboard.vue?vue&type=script&lang=js"
import style0 from "./MensalidadesDashboard.vue?vue&type=style&index=0&id=9c468866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c468866",
  null
  
)

export default component.exports